<section class="after-login">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div
                    class="title-strip my-5 d-flex justify-content-between align-items-center flex-column flex-sm-row gap-3 gap-sm-0">
                    <h2 class="text-primary">Manage Cards</h2>
                    <a (click)="openAddCardModal(addNewCardModal)" class="btn btn-success cursor-pointer">Add
                        Card</a>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="table-box overflow-hidden">
                    <div class="table-responsive">
                        <table class="table mb-0">
                            <thead>
                                <tr>
                                    <th>CARD NUMBER</th>
                                    <th>STATUS</th>
                                    <th>ACTION</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (card of cards; track card;let i = $index) {

                                <tr>
                                    <td>
                                        <span>{{ card.cc_number }}</span>
                                    </td>
                                    <td>
                                        <div class="d-flex align-items-center">
                                            <span>{{ card.is_active == "1" ? "Active" : "Inactive" }}</span>
                                            @if (card?.is_default) {
                                            <span class="badge badge-green ms-3">Primary</span>
                                            }
                                        </div>
                                    </td>
                                    <td>
                                        <div class="d-flex align-items-center">
                                            <a (click)="!card?.is_default ? markasDefault(card):''"
                                                [ngbTooltip]="!card?.is_default?'Mark As Default':'Default Card'"
                                                class="delete-btn text-default cursor-pointer">
                                                <i class="fa-regular fa-credit-card fs-5"></i>
                                            </a>
                                            <a (click)="openConfirmationPopup(changeCardModal,card)" [ngbTooltip]="
                                            cards?.length == 1 && card?.is_default
                                              ? 'Default Card can not be deleted'
                                              : ''
                                          " [class.disabled]="cards?.length == 1 && card?.is_default"
                                                class="ms-3 delete-btn text-danger cursor-pointer">
                                                <i class="fa-solid fa-trash-can fs-5"></i>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                                }
                                @empty {
                                <tr class="table-row">
                                    <td colspan="3" class="text-center">No Records to Show!</td>
                                </tr>
                                }

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<!-- Add new Card modal -->

<ng-template #addNewCardModal let-modal>
    <div class="modal-header">
        <h5 class="text-info mb-0" id="exampleModalLongTitle">
            Add New Card
        </h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="form-inner">
            <form [formGroup]="addCreditCardForm" id="add_new_credit_card_form">
                <div class="row">
                    <div class="col-md-6 mb-4">
                        <div class="label-moves-up">
                            <input type="text" trim="blur" id="cc_holder_name" name="cc_holder_name"
                                formControlName="cc_holder_name" placeholder="Card Holder Name" class="form-control" />
                        </div>
                        @if (
                        (addCreditCardForm?.controls?.cc_holder_name?.touched ||
                        addCreditCardForm?.controls?.cc_holder_name?.dirty ||
                        submittedNewCard) &&
                        !addCreditCardForm?.controls?.cc_holder_name?.valid &&
                        !addCreditCardForm?.controls?.cc_holder_name?.pending
                        ) {

                        @if (addCreditCardForm?.controls?.cc_holder_name?.errors.required) {
                        <span class="text-danger error">Card Holder Name is required</span>
                        }
                        }

                    </div>
                    <div class="col-md-6 mb-4">
                        <div class="label-moves-up">
                            <input class="form-control" formControlName="card_number" id="card_number"
                                name="card_number" type="text" trim="blur" maxlength="19" placeholder="Card Number"
                                ccNumber #ccNumber="ccNumber" />
                        </div>
                        @if (
                        (addCreditCardForm?.controls?.card_number?.touched ||
                        addCreditCardForm?.controls?.card_number?.dirty ||
                        submittedNewCard) &&
                        !addCreditCardForm?.controls?.card_number?.valid &&
                        !addCreditCardForm?.controls?.card_number?.pending
                        ) {
                        <span class="text-danger error">
                            @if (addCreditCardForm?.controls?.card_number?.errors.required) {
                            Card Number is required
                            }
                            @if (
                            addCreditCardForm?.controls?.card_number?.value &&
                            addCreditCardForm?.controls?.card_number?.errors.ccNumber
                            ) {
                            Please Enter Valid Card Number
                            }
                        </span>
                        }
                    </div>
                </div>
                @if (cardType) {
                <div>
                    {{ cardType }}
                    <img src="{{ defaultImagePath }}icon/{{ cardType }}" />
                </div>
                }
                <div class="row">
                    <div class="col-md-6 mb-4">
                        <div class="label-moves-up">
                            <input class="form-control" formControlName="card_expiry" id="card_expiry"
                                name="card_expiry" type="text" trim="blur" placeholder="MM / YY" ccExp />
                        </div>

                        @if (
                        (addCreditCardForm?.controls?.card_expiry?.touched ||
                        addCreditCardForm?.controls?.card_expiry?.dirty ||
                        submittedNewCard) &&
                        !addCreditCardForm?.controls?.card_expiry?.valid &&
                        !addCreditCardForm?.controls?.card_expiry?.pending
                        ) {
                        <span class="text-danger error">
                            @if ( addCreditCardForm?.controls?.card_expiry?.errors.required) {
                            Card Expiry Date is required
                            }
                            @if (
                            addCreditCardForm?.controls?.card_expiry?.value &&
                            addCreditCardForm?.controls?.card_expiry?.errors.expDate
                            ) {
                            Please enter valid Expiry Date
                            }
                        </span>
                        }
                    </div>
                    <div class="col-md-6 mb-4">
                        <div class="label-moves-up">
                            <input class="form-control" formControlName="card_cvv" id="card_cvv" name="card_cvv"
                                maxlength="4" type="text" trim="blur" placeholder="CVV" ccCVC />
                        </div>
                        @if (
                        (addCreditCardForm?.controls?.card_cvv?.touched ||
                        addCreditCardForm?.controls?.card_cvv?.dirty ||
                        submittedNewCard) &&
                        !addCreditCardForm?.controls?.card_cvv?.valid &&
                        !addCreditCardForm?.controls?.card_cvv?.pending
                        ) {
                        @if (addCreditCardForm?.controls?.card_cvv?.errors.minlength) {
                        <span class="text-danger error">Minimum 3 digits required</span>
                        }
                        }
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-6">
                        <div class="form-check">
                            <input class="form-check-input select-checkbox" type="checkbox" formControlName="is_default"
                                id="is_default" name="is_default" />
                            <label class="form-check-label mt-1" for="flexCheckDefault">
                                Mark as Default
                            </label>
                        </div>
                    </div>
                </div>
                @if (addCreditCardForm?.controls?.is_default?.value) {
                <div class="col-md-12 row">
                    <p class="m-l-10">
                        <strong class="m-l-15">Note:</strong>
                        Now onwards, this new added card is used for all services and
                        subscription scheduler.
                    </p>
                </div>

                }
                <div class="row">
                    <div class="col-12 text-end">
                        <button type="submit" class="btn btn-success next" [ladda]="isCardAdding"
                            (click)="saveNewCreditCard()">
                            <span class="left-icon save-icon">Save</span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</ng-template>


<!-- manage card -->

<ng-template #changeCardModal let-modal>
    <div class="modal-header">
        <h5 class="text-info" id="exampleModalLongTitle">
            Remove Default Card
        </h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-12 mb-2">
                <div class="alert alert-info">
                    <strong>Note:</strong>
                    Now onwards, this selected card is used for all services and
                    subscription scheduler.
                </div>
            </div>
            <div class="col-12">
                <label class="mb-1 text-primary small">Change Card: &nbsp;</label>
                <select class="form-control form-select" [(ngModel)]="selectedCard">
                    <option value="">Select Your Card</option>
                    @for (card of filteredCard; track $index) {
                    <option [ngValue]="card?.id" [disabled]="card?.is_default">
                        {{ card?.cc_number }}
                    </option>
                    }
                </select>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-success next" (click)="confirmCard()" [disabled]="!selectedCard">
            <span>Confirm</span>
        </button>

        <button class="btn btn-outline-success prev" data-dismiss="modal" (click)="modal.dismiss('Cross click')">
            <span class="left-icon close-icon">Close</span>
        </button>

    </div>
</ng-template>